import type {
    AuthorizedMedicationInfoFragment,
    MedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../../graphql/generated/graphql';
import type { MedicationOverride } from '../../hooks/use-config-api';
import type { DrugProgram, NdcDefinition } from '../../types/drug-config';
import { getMedicationNdc } from '../get-medication-ndc';

type MedicationFragment =
    | AuthorizedMedicationInfoFragment
    | MedicationInfoFragment
    | UnknownMedicationInfoFragment;

export const getNdcDefinition = (
    drugProgram: DrugProgram,
    medication: MedicationFragment | MedicationOverride | undefined
): NdcDefinition | undefined => {
    const ndc = getMedicationNdc(medication);

    if (!ndc) {
        return;
    }

    return getNdcDefinitionByNdc(drugProgram, ndc);
};

export const getNdcDefinitionByNdc = (
    drugProgram: DrugProgram,
    ndc: string | undefined
) => {
    if (!ndc) {
        return undefined;
    }

    let ndcDefinition: NdcDefinition | undefined;
    for (const drugConfig of drugProgram.drugConfigs) {
        ndcDefinition = drugConfig.ndcDefinitions.find(
            (definition) => definition.ndc === ndc
        );
        if (ndcDefinition) {
            break;
        }
    }

    return ndcDefinition;
};
